import { render } from "./TopicsList.vue?vue&type=template&id=5dd0e934"
import script from "./TopicsList.vue?vue&type=script&lang=js"
export * from "./TopicsList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-protal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__